// extracted by mini-css-extract-plugin
export default {"menu-map":"style_menu-map__sHxxw","track-vessel":"style_track-vessel__-SJ4x"};